import Http from "../commons/utils/Http";
import {errorHandling} from "../commons/utils/error";

class functionsService {

    async getAll(page) {
        try {
            let response = await Http.get(`/functions/get-all?offset=${page}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getId(id) {
        try {
            let response = await Http.get(`/functions/get-by?field=id&value=${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async search(search) {
        try {
            let response = await Http.get(`/functions/search?search=${search}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async insert(data) {
        try {
            let response = await Http.post(`/functions`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async update(data) {
        try {
            let response = await Http.put(`/functions`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async delete(id) {
        try {
            let response = await Http.delete(`/functions/${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getFunctions(page) {
        try {
            let response = await Http.get(`/functions/get-functions`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getFunctionsByModule(id) {
        try {
            let response = await Http.get(`/functions/get-functions-by-module?id=${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

}

export default new functionsService();